/**
 * Returns props for a highlight span. Accepts only CSS color values (hex, rgb, rgba, hsl, named).
 * When empty, returns no props so the span inherits the title/heading color.
 *
 * @param color - Optional CSS color (e.g. "#0156eb", "rgb(37, 99, 235)", "blue"). Not Tailwind classes.
 * @returns Props suitable for spreading onto a <span> (empty when no color, or { style: { color } }).
 */
export function getHighlightSpanProps(color: string | undefined): {
  className?: string;
  style?: { color: string };
} {
  if (!color?.trim()) return {};
  return { style: { color: color.trim() } };
}
